/* eslint-disable jsx-a11y/img-redundant-alt */
import { ParentLayout } from "../../../layout/parentLayout";
import { useCallback, useEffect, useRef, useState } from "react";
import Pagination from "../../../constants/Pagination";
import { useFilters } from "../../../context/filterContext";
import TutorsCard from "../../../components/TutorsCard";
import Loader from "../../../constants/Loader";
import NewSideBarParent from "../../../components/NewSideBarParent";
import { GRADE_TYPE, GRADE_TYPE_NAME, TEACHING_WRITTEN, TeachingLanguage, TUTOR_TYPE } from "../../../constants/enums";
import { useGetAllTypeTutorQuery } from "../../../service/parentDashboard";
import { useSearchParams } from "react-router-dom";
import { CircularProgress, MenuItem, Select } from "@mui/material";

type Filter = {
  exp: string,
  teching: string[],
  language: string,
  gender: string,
  rating: string,
  curriculam: string[],
  class: string[]
}

const CURRICULUM_WRITTEN: Record<string, string> = {
  "1": "National",
  "2": "Cambridge",
  "3": "IB",
  "4": "American"
};


export default function ParentPopularTutor() {
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [data1, setData1] = useState<any>([])
  const observerRef = useRef<any | null>(null)

  // const { filters, value, time, selectedSubjects } = useFilters();
  const [searchParams, setSearchParams] = useSearchParams();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true)
  // const homeSubject = searchParams.get("subject") || "";
  const [filters, setFilters] = useState<Filter>({
    exp: searchParams.get("exp") || "",
    teching: searchParams.get("teching")?.split(",") || [],
    language: searchParams.get("language") || "",
    gender: searchParams.get("gender") || "",
    rating: searchParams.get("rating") || "",
    curriculam: searchParams.get("curriculam")?.split(",") || [],
    class: searchParams.get("class")?.split(",") || [],
  });

  const isAnyFilterApplied = filters
    ? Object.values(filters).some((val) => {
      if (Array.isArray(val)) return val.length > 0; // non-empty array
      if (typeof val === "string") return val.trim() !== ""; // non-empty string
      return val !== null && val !== undefined; // other values
    })
    : false;



  // const subjectsFilter = selectedSubjects
  //   ?.map((item) => ({ name: item }))
  //   .filter((itex) => itex.name !== homeSubject);

  // let body = {
  //   ...(filters?.experience
  //     ? { totalTeachingExperience: Number(filters.experience) }
  //     : null),
  //   ...(filters?.curriculam?.length
  //     ? { curriculum: filters?.curriculam }
  //     : null),
  //   ...(filters?.teachingStyle?.length
  //     ? { teachingStyle: filters?.teachingStyle }
  //     : null),
  //   ...(filters?.verification
  //     ? {
  //       documentVerification:
  //         Number(filters?.verification) === 1 ? true : false,
  //     }
  //     : null),
  //   ...(filters?.lang ? { teachingLanguage: Number(filters?.lang) } : null),
  //   ...(filters?.gender ? { gender: filters?.gender } : null),
  //   ...(filters?.rating ? { avgRating: Number(filters?.rating) } : null),
  //   ...(value[0] > 5 ? { startPrice: value[0] } : null),
  //   ...(value[1] < 1000 ? { endPrice: value[1] } : null),
  //   ...(time?.startTime ? { startTime: time?.startTime } : null),
  //   ...(time?.endTime ? { endTime: time?.endTime } : null),
  //   ...(filters?.grade?.length
  //     ? { classes: filters?.grade?.map((data) => ({ name: data })) }
  //     : null),
  //   ...(selectedSubjects?.length > 0 || homeSubject
  //     ? {
  //       subjects:
  //         subjectsFilter?.length > 0
  //           ? subjectsFilter
  //           : [{ name: homeSubject }],
  //     }
  //     : null),
  //   ...(filters?.latitude ? { latitude: filters.latitude } : null),
  //   ...(filters?.longitude ? { longitude: filters.longitude } : null),
  // };

  const Body = {
    ...(filters?.exp
      ? { totalTeachingExperience: Number(filters.exp) }
      : null),
    ...(filters?.teching?.length
      ? { teachingStyle: filters?.teching?.map((t: string) => Number(t)) }
      : null),

    ...(filters?.language ? { teachingLanguage: Number(filters?.language) } : null),
    ...(filters?.gender ? { gender: filters?.gender } : null),
    ...(filters?.rating ? { avgRating: Number(filters?.rating) } : null),
    ...(filters?.curriculam?.length
      ? { curriculum: filters?.curriculam.map((c: string | number) => Number(c)) }
      : null),

    ...(filters?.class?.length
      ? { classes: filters?.class?.map((data) => Number(data)) }
      : null),


  }

  const { data, isSuccess, isLoading, isFetching, refetch } = useGetAllTypeTutorQuery({
    page: page,
    limit: 12,
    type: TUTOR_TYPE.POPULAR,
    body: Body
  });

  const lastElementRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (isLoading || isFetching) return;

      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting && hasNextPage) {
            setPage((prev) => prev + 1);
          }
        },
        {
          threshold: 0.5,      // fire when 50% visible
          rootMargin: "100px", // preload earlier
        }
      );

      if (node) observerRef.current.observe(node);
    },
    [isLoading, isFetching, hasNextPage]
  );


  // onChange handler for the page
  // const onPageChange = (newPage: number) => {
  //   setPage(newPage);
  //   setTimeout(() => {
  //     window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top after a brief delay
  //   }, 0);
  // };
  // let totalPages = Math.ceil(count / 12);







  // ✅ Generic change handler
  const handleChange = (field: keyof Filter, value: string | string[]) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const renderWithCount = (selected: string[], mapper: (val: string) => string, placeholder: string) => {
    if (!selected.length) return placeholder;
    const first = mapper(selected[0]);
    const restCount = selected.length - 1;
    return restCount > 0 ? `${first} +${restCount}` : first;
  };

  useEffect(() => {
    setPage(1);
    setData1([]);
    setHasNextPage(true);
  }, [filters]);

  useEffect(() => {
    if (isSuccess && data?.data?.data) {
      setCount(data?.data?.total);

      setData1((prev: any) => {
        const newData = page === 1
          ? [...data.data.data] 
          : [...prev, ...data.data.data]; 

        const unique = Array.from(
          new Map(newData.map(item => [item._id, item])).values()
        );

        return unique;
      });
    }

    if (data?.data?.data?.length < 12) {
      setHasNextPage(false);
    }
  }, [isSuccess, data, page]);


  useEffect(() => {
    const params: any = {};
    Object.keys(filters).forEach((key) => {
      const val = (filters as any)[key];
      if (Array.isArray(val) && val.length > 0) {
        params[key] = val.join(",");
      } else if (!Array.isArray(val) && val) {
        params[key] = val;
      }
    });
    setSearchParams(params);
  }, [filters, setSearchParams]);


  return (
    <>
      <ParentLayout className="role-layout">
        <main className="content">
          <section className="ut_spc home_wrp">
            <div className="conta_iner v2 parent_dash tutor_fx">
              <div className="gap_m">
                <NewSideBarParent />
                <div className="rt_s">
                  <div className="role_head">
                    <h1 className="hd_3">Recommended Tutors</h1>
                  </div>
                  <ul className="cstmm_tabs cstmmm_tabs_1">
                    <li>
                      <Select
                        value={filters.exp}
                        onChange={(e) => handleChange("exp", e.target.value)}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Experience
                        </MenuItem>
                        <MenuItem value="1" >
                          1
                        </MenuItem>
                        <MenuItem value="2" >
                          2
                        </MenuItem>
                        <MenuItem value="3" >
                          3
                        </MenuItem>
                        <MenuItem value="4" >
                          4
                        </MenuItem>
                        <MenuItem value="5" >
                          5+
                        </MenuItem>

                      </Select>
                    </li>
                    <li>
                      <Select
                        multiple
                        value={filters.teching}
                        onChange={(e) =>
                          handleChange("teching", e.target.value as string[])
                        }
                        fullWidth
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected.length) return "Select Teaching Style";

                          const first = TEACHING_WRITTEN[+selected[0]];
                          const restCount = selected.length - 1;

                          return restCount > 0 ? `${first} +${restCount}` : first;
                        }}

                      >
                        {Object.entries(TEACHING_WRITTEN).map(([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                    </li>
                    <li>
                      <Select
                        value={filters.language}
                        onChange={(e) => handleChange("language", e.target.value)}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Language
                        </MenuItem>
                        <MenuItem value={TeachingLanguage.ENGLISH} >
                          English
                        </MenuItem>
                        <MenuItem value={TeachingLanguage.ARABIC} >
                          Arabic
                        </MenuItem>
                        <MenuItem value={TeachingLanguage.BOTH} >
                          Both
                        </MenuItem>

                      </Select>
                    </li>
                    {/* Gender */}
                    <li>
                      <Select
                        value={filters.gender}
                        onChange={(e) => handleChange("gender", e.target.value)}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Gender
                        </MenuItem>
                        <MenuItem value="MALE" >
                          Male
                        </MenuItem>
                        <MenuItem value="FEMALE" >
                          Female
                        </MenuItem>

                      </Select>
                    </li>
                    {/* Rating */}
                    <li>
                      <Select
                        value={filters.rating}
                        onChange={(e) => handleChange("rating", e.target.value)}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Rating
                        </MenuItem>
                        <MenuItem value="1" >
                          1.0
                        </MenuItem>
                        <MenuItem value="2" >
                          2.0
                        </MenuItem>
                        <MenuItem value="3" >
                          3.0
                        </MenuItem>
                        <MenuItem value="4" >
                          4.0
                        </MenuItem>
                        <MenuItem value="5" >
                          5.0
                        </MenuItem>
                      </Select>
                    </li>
                    {/* Curriculam */}
                    <li>
                      <Select
                        multiple
                        value={filters.curriculam}
                        onChange={(e) =>
                          handleChange("curriculam", e.target.value as string[])
                        }
                        fullWidth
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected.length) return "Select Curriculam";
                          const first = CURRICULUM_WRITTEN[selected[0]];
                          const restCount = selected.length - 1;
                          return restCount > 0 ? `${first} +${restCount}` : first;
                        }}


                      >
                        <MenuItem value="1">National Curriculam</MenuItem>
                        <MenuItem value="2">Cambridge Curriculam</MenuItem>
                        <MenuItem value="3">IB Curriculam</MenuItem>
                        <MenuItem value="4">American Curriculam</MenuItem>
                      </Select>
                    </li>
                    {/* Class */}
                    <li>
                      <Select
                        multiple
                        value={filters.class}
                        onChange={(e) =>
                          handleChange("class", e.target.value as string[])
                        }
                        fullWidth
                        displayEmpty
                        renderValue={(selected) =>
                          renderWithCount(selected, (s) => GRADE_TYPE_NAME[+s], "Select Class")
                        }

                      >
                        {Object.entries(GRADE_TYPE).map(([key, value]) => (
                          <MenuItem key={value} value={String(value)}>
                            {GRADE_TYPE_NAME[value]}
                          </MenuItem>
                        ))}
                      </Select>
                    </li>
                    {isAnyFilterApplied && (
                      <button
                        className="btn primary"
                        style={{ backgroundColor: "red" }}
                        onClick={() => {
                          setFilters({
                            exp: "",
                            teching: [],
                            language: "",
                            gender: "",
                            rating: "",
                            curriculam: [],
                            class: [],
                          });

                          setSearchParams({});
                        }}
                      >
                        Reset Filters
                      </button>
                    )}
                  </ul>

                  <div className="tutoer_list gap_m">
                    {data1?.length ? (
                      data1?.map((item: any, index: number) => {
                        return (
                          <TutorsCard
                            item={item}
                            ref={index === data1?.length - 1 ? lastElementRef : null}
                          />
                        )
                      })
                    ) : (
                      isLoading ?
                        <div style={{ textAlign: 'center' }}> <CircularProgress size={40} /></div> :
                        <h3 style={{ textAlign: "center" }}>No Tutor found</h3>
                    )}

                  </div>
                  {/* {data1 > 0 && (
                    <Pagination
                      module={data?.data?.data}
                      page={page}
                      onPageChange={onPageChange}
                      totalPages={totalPages}
                    />
                  )} */}
                </div>
              </div>
            </div>
          </section>
        </main>
      </ParentLayout>
    </>
  );
}

